module.exports = __webpack_public_path__ + "img/viewBG.9ad6170d.png";